// Cross-tab chime dedupe for the DeskNotes panel.
//
// Every Zenoti tab on one desk computer runs its own copy of the panel and
// polls on its own. Without this, one new request chimes once per tab. All
// those panels share the same localStorage (same ops origin under the same
// top-level site), so the first tab to notice a new key writes a claim and
// chimes; the others see the claim and stay quiet. Pop-open is NOT gated by
// this — every tab pops open (some desk computers have no speaker).
//
// Timestamps are Date.now() on purpose: this is a same-machine freshness
// check, not a Pacific-wall-time value, so the repo's pacific-as-UTC rule
// does not apply here.

export const CHIME_CLAIM_PREFIX = 'desk-notes-chimed:';
export const CHIME_CLAIM_TTL_MS = 60 * 1000;        // another tab's claim counts for this long
export const CHIME_SWEEP_AGE_MS = 10 * 60 * 1000;   // claims older than this are deleted

/**
 * Try to claim each key for THIS tab. Returns the keys this tab won (the
 * caller chimes once if the list is non-empty). On any storage failure every
 * key is returned, so a tab with blocked storage behaves like today (chimes).
 */
export function claimChime(storage, keys, now) {
  const won = [];
  for (const key of keys) {
    const slot = CHIME_CLAIM_PREFIX + key;
    try {
      const at = Number(storage.getItem(slot));
      if (Number.isFinite(at) && at > 0 && now - at < CHIME_CLAIM_TTL_MS) continue; // someone else has it
      storage.setItem(slot, String(now));
      won.push(key);
    } catch {
      won.push(key);
    }
  }
  return won;
}

/** Delete claim slots older than CHIME_SWEEP_AGE_MS. Never throws. */
export function sweepChimeClaims(storage, now) {
  try {
    const stale = [];
    for (let i = 0; i < storage.length; i += 1) {
      const k = storage.key(i);
      if (!k || !k.startsWith(CHIME_CLAIM_PREFIX)) continue;
      const at = Number(storage.getItem(k));
      if (!Number.isFinite(at) || now - at > CHIME_SWEEP_AGE_MS) stale.push(k);
    }
    stale.forEach((k) => storage.removeItem(k));
  } catch { /* storage blocked — nothing to clean */ }
}
